import styled from 'styled-components'

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;

  @media (min-width: 1200px) {
    padding-top: 10px;
  }

  strong {
    font-weight: 600;
  }
`

export const Attribute = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    "left-top right"
    "left-bottom right";
  column-gap: 30px;
  row-gap: 8px;
  width: 100%;
  align-items: center;
  min-height: 50px;

  /* Ensure the right column is a single area that spans both rows.
     Child elements should set their grid-area to "right", "left-top" or "left-bottom". */
`

export const Label = styled.p`
  font-weight: 500;
  margin-bottom: 0;
  grid-area: "left-top";
`

export const Value = styled.p`
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  grid-area: "left-bottom";
`

export const ChangeButton = styled.a`
  background-color: transparent;
  border: 1px solid ${(props) => props.theme.palette.primary.main};
  padding: 8px 20px;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  grid-area: right;
  width: fit-content;
  justify-self: end;

  &:hover {
    background-color: ${(props) => props.theme.palette.primary.main};
    color: #ffffff;
    text-decoration: none;
  }
`
